
/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */

import Cleave from 'cleave.js'

require('./bootstrap')

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// import vuelist from './vueList/List.vue'
// Vue.component('vuelist', vuelist);
// import notifier from './components/Notifier.vue'
// Vue.component('notifier', notifier);

Vue.component('datepicker', require('vuejs-datepicker'))

Vue.component('clinicV2', require('./components/clinicV2/form.vue').default)

Vue.component('addressForm', require('./components/address/form.vue').default)

Vue.component('vuelist', require('./vueList/List.vue').default)

Vue.component('cardsList', require('./components/card.list.vue').default)
Vue.component('voucherList', require('./components/voucher.list.vue').default)
Vue.component('log', require('./components/Log.vue').default)
Vue.component('customerTrash', require('./components/customer-trash.vue').default)
Vue.component('customerSendReviewSms', require('./components/customer-send-review-sms.vue').default)
Vue.component('customerSendMailButton', require('./components/customer-send-mail-button.vue').default)

Vue.component('monthPicker', require('./components/MonthPicker.vue').default)

Vue.component('notifier', require('./components/Notifier.vue').default)

Vue.component('productPrices', require('./components/product.prices.vue').default)
Vue.component('productAffiliateApiMap', require('./components/product.affiliate.api.map.vue').default)

Vue.component('reports', require('./components/reports.vue').default)

Vue.component('companyCustomerForm', require('./components/company-customers/companies/layout.vue').default)

Vue.component('subscriptionForm', require('./components/company-customers/subscriptions/layout.vue').default)

Vue.component('bs5Wrapper', require('./components/company-customers/bs5-wrapper.vue').default)
Vue.component('employeesList', require('./components/company-customers/employees/list.vue').default)
Vue.component('subscriptionsList', require('./components/company-customers/subscriptions/list.vue').default)
Vue.component('companiesList', require('./components/company-customers/companies/list.vue').default)
Vue.component('clinicsList', require('./components/clinicV2/list-clinics.vue').default)
Vue.component('prospectsList', require('./components/clinicV2/list-prospects.vue').default)
Vue.component('timezynkTreatments', require('./components/company-customers/timezynk-treatments/index.vue').default)
Vue.component('quotationsNewList', require('./components/quotations-new-list.vue').default)
Vue.component('quotationsNewView', require('./components/quotations-new-view.vue').default)
Vue.component('quotationsNewPrices', require('./components/quotations-new-prices.vue').default)
Vue.component('faqPages', require('./components/faq-pages/index.vue').default)
Vue.component('billing', require('./components/company-customers/billing/list.vue').default)
Vue.component('benifyExcel', require('./components/benify-excel.vue').default)

Vue.component('dealsList', require('./components/deals-list.vue').default)
Vue.component('dealsForm', require('./components/deals-form.vue').default)

Vue.component('deviationsList', require('./components/deviations-list.vue').default)

Vue.component('scraperList', require('./components/scraper-list.vue').default)
Vue.component('scraperUpload', require('./components/scraper-upload.vue').default)

window.bus = new Vue()

Vue.directive('cleave', {
    inserted: (el, binding) => {
        el.cleave = new Cleave(el, binding.value || {})
    },
    update: (el) => {
        const event = new Event('input', { bubbles: true })
        setTimeout(function () {
            el.value = el.cleave.properties.result
            el.dispatchEvent(event)
        }, 100)
    }
})

new Vue({
    el: '#app',

    created () {
        bus.$on('collapse-panels', function () {
            const panels = Cookies.get()
            for (const panel in panels) {
                if (panel.indexOf('/') !== -1) {
                    return
                }

                if ($('#' + panel).hasClass('panel-collapse')) {
                    $('#' + panel).collapse('show')
                }
            }
        })
    }

})

$(document).ready(function () {
    if ($('#modal_timezynk').length) {
        $('#modal_timezynk').modal('show')
    }

    $('body').on('click', '.no-collapsable', function (e) {
        e.stopPropagation()
    })

    $('body').on('shown.bs.collapse', '.panel .panel-collapse', function () {
	    const active = $(this).attr('id')

    	Cookies.set(active, '1')
    })

    $('body').on('hidden.bs.collapse', '.panel .panel-collapse', function () {
	    const active = $(this).attr('id')

    	Cookies.remove(active)
    })

    $('.navbar-brand').on('click', function () {
        window.location = '/'
    })

    $('#marketingText').on('keyup', function () {
        $('#marketingTextPreview').html($('#marketingText').val())
    })

    $('#sms_marketing_url').on('keyup', function () {
        $('#marketingUrlPreview').html($('#sms_marketing_url').val())
    })

    /*
    var panels = Cookies.get();

    for (var panel in panels){
        if ($("#"+panel).hasClass('panel-collapse')) {
            $("#"+panel).collapse("show");
        }
    }
    */

    // Hanterar fält i views/admin/affiliates/form.blade.php
    $('#affiliate_form #product_area_id').change(function () {
        const preselect_account_id = $(this).find(':selected').data('account-id')

        if (preselect_account_id) {
            $('#account_id').val(preselect_account_id)
        }
    })

    bus.$emit('collapse-panels')
})
